import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { GenreChip } from "@/components/GenreChip";

export function GenreFilter({ genres, selected, onToggle, onClear, prefix }) {
  const [open, setOpen] = useState(false);
  const slug = (n) => n.toLowerCase().replace(/\s+/g, "-");
  return (
    <div className="mb-10" data-testid={`${prefix}-genre-filter`}>
      <div className="font-mono text-[10px] text-white/40 uppercase tracking-[0.25em] mb-3 hidden sm:block" data-testid={`${prefix}-genres-hint`}>Géneros · puedes seleccionar varios a la vez</div>
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid={`${prefix}-genres-toggle`} aria-expanded={open}
        className="sm:hidden w-full flex items-center justify-between gap-3 px-4 py-3 rounded-xl border border-white/10 bg-[#111116] text-left">
        <span className="min-w-0">
          <span className="block font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">Géneros · varios a la vez</span>
          <span className="block text-sm text-white truncate" data-testid={`${prefix}-genres-summary`}>{selected.length ? selected.map((s) => genres.find((g) => g.name.toLowerCase() === s)?.name || s).join(" + ") : "Todos"}</span>
        </span>
        <span className="flex items-center gap-2 shrink-0">
          {selected.length > 0 && <span className="w-5 h-5 rounded-full bg-red-600 text-white text-[10px] font-bold flex items-center justify-center">{selected.length}</span>}
          <ChevronDown className={`w-4 h-4 text-white/60 transition-transform ${open ? "rotate-180" : ""}`} />
        </span>
      </button>
      <div className={`${open ? "flex" : "hidden"} sm:flex flex-wrap gap-2 mt-3 sm:mt-0 max-h-72 sm:max-h-none overflow-y-auto sm:overflow-visible pr-1`} data-testid={`${prefix}-genres`}>
        <GenreChip active={!selected.length} onClick={onClear} testid={`${prefix}-genre-all`}>Todos</GenreChip>
        {genres.map((g) => (
          <GenreChip key={g.name} active={selected.includes(g.name.toLowerCase())} onClick={() => onToggle(g.name)} testid={`${prefix}-genre-${slug(g.name)}`}>
            {g.name} <span className="opacity-50 ml-1">{g.count}</span>
          </GenreChip>
        ))}
      </div>
    </div>
  );
}
